/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Coverage of one group in one 15-minute slot.
 */
export type shifts_SlotDTO = {
    babies: number;
    children: number;
    end: string;
    min_qualified_staff: number;
    min_staff_floor_applied: boolean;
    required_staff: number;
    scheduled_qualified_staff: number;
    scheduled_staff: number;
    start: string;
    status: shifts_SlotDTO.status;
    /**
     * UnitID is the group combination whose window contains this slot, else null.
     */
    unit_id?: string;
    weighted_children: number;
};
export namespace shifts_SlotDTO {
    export enum status {
        SURPLUS = 'SURPLUS',
        SUFFICIENT = 'SUFFICIENT',
        WARNING = 'WARNING',
        CRITICAL = 'CRITICAL',
        NO_CHILDREN = 'NO_CHILDREN',
        NOT_CONFIGURED = 'NOT_CONFIGURED',
        IN_UNIT = 'IN_UNIT',
    }
}

